import type { URLOpenListenerEvent } from "@capacitor/app";
import { App } from "@capacitor/app";
import { Blac } from "blac-next";
import type { FC } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import reportErrorSentry from "src/lib/reportErrorSentry";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import { historyState } from "src/state/state";

export const getInAppPath = (url: string): string | undefined => {
  try {
    const { pathname, search, hash } = new URL(url);
    return `${pathname}${search}${hash}`;
  } catch {
    return undefined;
  }
};

const AppUrlListener: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      const path = getInAppPath(event.url);
      if (path) {
        navigate(path);
      }
    }).catch((err: unknown) => {
      reportErrorSentry(err);
    });
  }, []);

  useEffect(() => {
    historyState.locationChange(location);
    const appViewState = Blac.getBloc(AppViewCubit);
    appViewState.navigate = navigate;
  }, [location]);

  return null;
};

export default AppUrlListener;
